module.exports = __webpack_public_path__ + "assets/img/noStatus.8cc95b08.png";